import { API_URL } from "../../config/apiUrl";

export const authEndpoints = {
  registerUrl: `${API_URL}/auth/register`,
  loginUrl: `${API_URL}/auth/login`,
};

export const routeEndpoints = {
  createRouteUrl: `${API_URL}/routes`,
  updateRouteUrl: `${API_URL}/routes?routeId={routeId}`,
  updateRouteOrderUrl: `${API_URL}/routes/order`,
  updateRouteAsSentUrl: `${API_URL}/routes/send`,
  getRoutesUrl: `${API_URL}/routes`,
  getRoutesByRouteIdUrl: `${API_URL}/routes/{id}`,
  getCancelledRoutesUrl: `${API_URL}/routes/cancelled`,
  getRoutesByDestinationTypeUrl: `${API_URL}/routes/destinationType/{id}?date={date}&search={search}`,
  createMarkerUrl: `${API_URL}/routes/marker`,
  deleteMarkerUrl: `${API_URL}/routes/marker/{id}`,
  softDeleteRouteUrl: `${API_URL}/routes/{id}`,
};

export const passengerEndpoints = {
  createPassengerUrl: `${API_URL}/passengers`,
  getCancelledPassengerUrl: `${API_URL}/passengers/cancelled`,
};

export const destinationEndpoints = {
  getDestinationsUrl: `${API_URL}/destinations`,
  getDestinationsByDateUrl: `${API_URL}/destinations/date?date={date}`,
  createDestinationUrl: `${API_URL}/destinations`,
};

export const routeGroupEndpoints = {
  getRouteGroupsUrl: `${API_URL}/route-groups?date={date}`,
  getForCopyRouteGroupsUrl: `${API_URL}/route-groups/copy?date={date}`,
  createRouteGroupUrl: `${API_URL}/route-groups`,
  updateRouteGroupUrl: `${API_URL}/route-groups/{id}`,
  addRouteToRouteGroupUrl: `${API_URL}/route-groups/append-route/{id}`,
  deleteRouteFromRouteGroupUrl: `${API_URL}/route-groups/delete-route-from-route-group/{id}`,
  deleteRouteGroupUrl: `${API_URL}/route-groups/{id}`,
  copyRouteGroupToClipboardUrl: `${API_URL}/route-groups/individually/copy`,
};

export const connectionEndpoints = {
  getConnectionsUrl: `${API_URL}/connections?date={date}`,
  createConnectionUrl: `${API_URL}/connections`,
  updateConnectionUrl: `${API_URL}/connections/{id}`,
  updateConnectionVehicleUrl: `${API_URL}/connections/vehicle/{id}`,
  updateConnectionDriverUrl: `${API_URL}/connections/driver/{id}`,
  deleteConnectionUrl: `${API_URL}/connections/{id}`,
};
